import { Component } from 'react';
import { Icon } from '@codex/icons';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getTranslation } from '../../translations/translations';

const DivWrapper = styled.div`
  .prd-channels {
    margin-bottom: 0;
    padding: 5px 0 2px;
    font-size: 13px;
    line-height: 20px;
    
    li {
      padding: 0 0 0 25px;

      @media ${({ theme }) => theme.breakpoints.mobile} {
        font-size: 14px;
      }
    }

    i {
      font-size: 24px;
      margin-top: -2px;
    }

    .dcg-icon-mail {
      padding-top: 3px;
      font-size: 18px;
    }

    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }

    .icon-spin {
      display: inline-block;
      -webkit-animation: spin 2s infinite linear;
      animation: spin 2s infinite linear;
    }

    a .icon-spin {
      display: inline-block;
      text-decoration: none;
    }
  }

  .channels-availability {
    .nostock {
      .email-when-back {
        cursor: pointer;
      }
    }
  }

  .resultList & {
    .product {
      .channels-availability {
        text-align: left;
        padding-left: 10px;

        ul {
          display: inline-block;
          text-align: left;
        }
      }
    }
  }

  [data-component="product-list-view"] {
    .channels-availability {
      padding-top: 5px;
      padding-bottom: 2px;

      .location {
        color: #666666;
        line-height: 20px;
        padding-bottom: 2px;
        padding-left: 4px;
        margin-bottom: 4px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        span {
          font-weight: bold;
        }
      }

      .location.available {
        span {
          color: #618e46;
        }
      }
    }
  }

  [data-component='product-list-view'] .channels-availability.pending-request {
    text-align: center;
    height: 45px;
  }

  [data-component='product-list-view'] .channels-availability.pending-request > ul {
    display: none !important;
  }

  @media ${({ theme }) => theme.breakpoints.desktop} {
    .resultList & .prd-channels {
      padding-left: 10px;
    }
  }
`;

export default class ChannelsAvailability extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fadeOutBackground: false
    };
  }

  /**
   * When placeSpecificAvailability becomes present in props, highlight channelsAvailability
   * in CSS, applied using fadeOutBackground state prop.
   * @param nextProps
   */
  // TODO: refactor this component preferably using react-hooks or use non deprecated methods from React
  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) { // eslint-disable-line camelcase
    if (nextProps.placeSpecificChannelsAvailability &&
      !this.props.placeSpecificChannelsAvailability) {
      this.setState({
        fadeOutBackground: true
      });
      this.fadeOutTimeoutID = setTimeout(
        () => this.setState({ fadeOutBackground: false }),
        7000
      );
    }
  }

  componentWillUnmount() {
    if (this.fadeOutTimeoutID) {
      clearTimeout(this.fadeOutTimeoutID);
    }
  }

  getIconClassName(channelType) {
    if (channelType === 'checkInStore') {
      return 'dcg-icon-spinner icon-spin';
    }

    if (this.isChannelAvailable(channelType)) {
      return 'dcg-icon-tick';
    }
    return 'dcg-icon-cross';
  }

  /**
   * If at least some delivery channel is available (default or place specific), return true.
   * @returns {boolean}
   */
  hasProductAvailableChannel() {
    if (this.props.placeSpecificChannelsAvailability) {
      const placeSpecific = this.props.placeSpecificChannelsAvailability;

      if ((placeSpecific.delivery && this.isChannelAvailable(placeSpecific.delivery.type)) ||
        (placeSpecific.inStore && this.isChannelAvailable(placeSpecific.inStore.type))) {
        return true;
      }
    }

    if (this.props.defaultChannelsAvailability) {
      const defaultAvailability = this.props.defaultChannelsAvailability;

      if ((defaultAvailability.delivery && this.isChannelAvailable(defaultAvailability.delivery.type)) ||
        (defaultAvailability.inStore && this.isChannelAvailable(defaultAvailability.inStore.type))) {
        return true;
      }
    }

    return false;
  }

  hasProductSpecificAvailability() {
    return this.props.placeSpecificChannelsAvailability &&
      (this.props.placeSpecificChannelsAvailability.inStore ||
        this.props.placeSpecificChannelsAvailability.delivery
      );
  }

  isChannelAvailable(channelType) {
    return [
      'collectInStoreAvailable',
      'homeDeliveryAvailable',
      'supplierDeliveryAvailable',
      'orderNowDeliveryLaterAvailable'
    ].includes(channelType);
  }

  renderDownload() {
    // According to old code, if product is download and has loaded specificAvailability,
    // change icon from download to tick.
    const iconClassName = this.hasProductSpecificAvailability()
      ? 'dcg-icon-tick' : 'dcg-icon-download';

    return (
      <ul className={'simple prd-channels'} data-product={'availability'}>
        <li className={'available'} data-availability={'downloadAvailable'}>
          <i className={iconClassName} />
          {getTranslation('downloadProductTranslation')}
        </li>
      </ul>
    );
  }

  renderEmailMeBack() {
    let emailMeBackClasses = 'simple prd-channels';

    emailMeBackClasses += this.props.isEmailMeBackHidden ? ' hidden' : '';

    return (
      <ul className={emailMeBackClasses} data-product={'availability'}>
        <li className={'nostock'}>
          <i className={'dcg-icon-cross'} />
          {getTranslation('emailMeBackFirstLineTranslation')}
        </li>
        <li className={'nostock'}>
          <span
            data-href={'#email-when-back-desktop'}
            data-fupid={this.props.id}
            className={'email-when-back'}
            onClick={(e) => {
              e.preventDefault();
              this.props.setEmailMeBackProductID(this.props.id);
            }}
          >
            <i className={'dcg-icon-mail'} />
            <span>{getTranslation('emailMeBackLinkTranslation')}</span>
          </span>
        </li>
      </ul>
    );
  }

  renderLocationLabel() {
    // If there is no placeSpecificAvailability, there is no label to render.
    // Default availability does not have label.
    if (!this.props.locationName) {
      return <noscript />;
    }

    const classNames = ['location'];

    if (this.hasProductAvailableChannel()) {
      classNames.push('available');
    } else {
      classNames.push('unavailable');
    }

    return (
      <div className={classNames.join(' ')}>
        {getTranslation('forDeliveryPlaceTranslation')}
        &nbsp;
        <span>
          {this.props.locationName}
        </span>
      </div>
    );
  }

  renderLocationAvailabilities() {
    // if placeSpecificAvailability is present, use that, has higher priority.
    const channel = this.hasProductSpecificAvailability()
      ? this.props.placeSpecificChannelsAvailability
      : this.props.defaultChannelsAvailability;

    if (channel.canBeDownloaded) {
      return this.renderDownload();
    } if (channel.showEmailMeBack) {
      return this.renderEmailMeBack();
    }

    return (
      <ul className={'simple prd-channels'} data-product={'availability'}>
        {[channel.delivery, channel.inStore].filter((el) => el)
          .map((availabilityChannel, i) => (
            <li
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className={this.isChannelAvailable(availabilityChannel.type) ? 'available' : 'unavailable'}
            >
              <i className={this.getIconClassName(availabilityChannel.type)} />
              <span
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: availabilityChannel.label }}
              />
            </li>
          ))}
      </ul>
    );
  }

  render() {
    const classNames = ['channels-availability'];

    if (this.props.pendingLocation === true) {
      classNames.push('pending-request');
    }

    if (this.state.fadeOutBackground === true) {
      classNames.push('bkg-fadeout');
    }

    return (
      <DivWrapper>
        <div
          className={classNames.join(' ')}
        >
          {this.props.pendingLocation
            ? <Icon icon={'Spinner'} size={'large'} spin />
            : (
              <>
                {this.renderLocationLabel()}
                {this.renderLocationAvailabilities()}
              </>
            )}
        </div>
      </DivWrapper>
    );
  }
}

ChannelsAvailability.propTypes = {
  defaultChannelsAvailability: PropTypes.shape({
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }).isRequired,
  placeSpecificChannelsAvailability: PropTypes.shape({
    delivery: PropTypes.shape({
      type: PropTypes.string
    }),
    inStore: PropTypes.shape({
      type: PropTypes.string
    })
  }),
  pendingLocation: PropTypes.bool,
  setEmailMeBackProductID: PropTypes.func,
  isEmailMeBackHidden: PropTypes.bool,
  id: PropTypes.string.isRequired,
  locationName: PropTypes.string
};

ChannelsAvailability.defaultProps = {
  placeSpecificChannelsAvailability: undefined,
  locationName: null,
  pendingLocation: false,
  setEmailMeBackProductID: () => {},
  isEmailMeBackHidden: false
};
